import type { Settings } from '@ant-design/pro-components';

export type ThemeMode = 'light' | 'dark' | 'system';
export type NavigationMode = 'side' | 'top' | 'mixed';
export type MenuType = 'single' | 'serviceGrid' | 'twoColumn' | 'splitServiceGrid';
export type AppLayoutSettings = Partial<Settings> & {
  themeMode?: ThemeMode;
  navigationMode?: NavigationMode;
  menuType?: MenuType;
  timeZone?: string;
};

export const timeZones = [
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Tokyo',
  'Asia/Singapore',
  'Europe/London',
  'Europe/Paris',
  'America/New_York',
  'America/Los_Angeles',
  'UTC',
];

export function normalizeSettings(settings: AppLayoutSettings): AppLayoutSettings {
  // 旧 mix 未分割时实际是完整侧栏；迁移保持用户眼前的布局，而非按枚举字面翻转。
  const navigationMode =
    settings.navigationMode ?? (settings.layout === 'top' ? 'top' : 'side');
  let menuType =
    settings.menuType ??
    (settings.siderMenuType === 'group' ? 'serviceGrid' : 'single');
  if (navigationMode === 'mixed') {
    if (menuType === 'twoColumn') menuType = 'single';
    if (menuType === 'splitServiceGrid') menuType = 'serviceGrid';
  }
  return {
    ...settings,
    navigationMode,
    menuType,
    themeMode:
      settings.themeMode ?? (settings.navTheme === 'realDark' ? 'dark' : 'light'),
    timeZone: timeZones.includes(settings.timeZone ?? '')
      ? settings.timeZone
      : 'Asia/Shanghai',
  };
}
